package com.wintermar.inspection.core.data

import kotlin.random.Random

object Uuid {
    private fun randHex(count: Int): String {
        val sb = StringBuilder(count)
        repeat(count) {
            sb.append(Random.nextInt(16).toString(16))
        }
        return sb.toString()
    }

    fun generate(): String {
        val variant = (8 + Random.nextInt(4)).toString(16)
        return "${randHex(8)}-${randHex(4)}-4${randHex(3)}-$variant${randHex(3)}-${randHex(12)}"
    }
}
